module.exports = __webpack_public_path__ + "img/apple-health-kit.d51988ee.jpeg";